import React from 'react';
import { Card } from 'components';
import { Typography, Avatar, Space } from 'antd';
import { renderAvatar, media } from 'helpers';
import styled from 'styled-components';

const StyledCard = styled(Card)`
	&& {
		min-width: 200px;
		margin-left: 2em;
		box-shadow: ${({ boxShadow }) => boxShadow || '0 12px 20px 0 rgba(0, 0, 0, 0.1), 0 17px 10px 0 rgba(0, 0, 0, 0.1)'};
		cursor: pointer;
		.ant-card-body {
			padding: 0;
			padding-top: 1em;

			${media.mobile`
				> .ant-typography {
					max-width: 120px;
				}
			`}
		}
		.ant-card-cover {
			height: 150px;
			img {
				height: 100%;
				object-fit: cover;
				border-radius: 10px 10px 0 0;
			}
		}
	}
`;

export default function ContentCard({ data, onClick, height = '280px', boxShadow, ...props }) {
	const avatar = renderAvatar(data.contentResPreview.path);
	return (
		<StyledCard {...props} boxShadow={boxShadow} height={height} className="ta-center" src={data.contentResPreview.path} onClick={() => onClick(data)}>
            <div style={{width:'100%', display:'flex', justifyContent: 'center', alignItems:'center', textAlign: 'center', flexDirection:'column',overflow: 'hidden',textOverflow:'ellipsis'}}>
			<Typography strong ellipsis={{ rows: 1 }}>
                <h4 style={{color:'orange'}}>
				{data.title}
                </h4>
			</Typography>
			<Space direction="vertical">
			<Typography.Paragraph strong style={{color:'orange', fontSize:'12px'}} ellipsis={{ rows: 1 }}>
				
            <Avatar style={{width:'25px', height:'25px'}} src={data.tutor.profileImage} /> {data.tutor.firstName + ' ' + data.tutor.lastName}
			
			</Typography.Paragraph>
			<Typography.Paragraph ellipsis={{ rows: 1 }} className="fs-09em">
				{data.description.slice(0,20) || '-'}...
			</Typography.Paragraph>
			</Space>
            </div>
		</StyledCard>
	);
}
